export default __webpack_public_path__ + "static/media/page35.6808bded.jpg";